function SiteTitle() {
  return (
    <div className='w-full'>
      <p className='text-4xl font-bold'>iKotoba</p>
    </div>
  )
}

export default SiteTitle;